"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//import process from 'process'
const wrappers_1 = require("quasar/wrappers");
const core_1 = require("@apollo/client/core");
const apollo_option_1 = require("@vue/apollo-option");
const error_1 = require("@apollo/client/link/error");
const auth_1 = require("../store/actions/auth");
exports.default = wrappers_1.boot(({ app, store, router, redirect }) => {
    //
    // Automatically show server errors, auth and custom flash messages from GraphQL requests restuls
    //
    const errorLink = error_1.onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
            // auto-log errors (DEV ONLY)
            let flashed = false;
            graphQLErrors.map((gqlErr) => {
                const message = gqlErr.message;
                const locations = gqlErr.locations;
                const path = gqlErr.path;
                const extensions = gqlErr.extensions;
                const debugMessage = gqlErr.debugMessage;
                const trace = gqlErr.trace;
                if (process.env.DEV) {
                    // const trace = (extensions.exception as any).stacktrace
                    if (locations && locations[0]) {
                        console.error(`[GraphQL error]: ${message}\nLine: ${locations[0].line}, Col: ${locations[0].column},\nPath: ${path}`);
                    }
                    if (debugMessage) {
                        console.error('[Debug msg]: ' + debugMessage);
                    }
                    if (trace && trace.length) {
                        console.error('Call: ' + trace[0].call);
                        console.error('Line: ' + trace[0].line);
                        console.error('File: ' + trace[0].file);
                    }
                    console.log(graphQLErrors);
                }
                // handle Unauthenticated Internal Server Error
                if (
                //extensions.category === 'authentication' &&
                message.includes('Unauthenticated')) {
                    // Unauthenticated request (user not authenticated (not logged-in))
                    if (store.getters['auth/user']) {
                        // Show notification only if user authenticated here, on application host, but unauthenticated on server.
                        // If unauthenticated here and on server notify makes no sense (in case request sent already).
                        app.config.globalProperties.$event.emit('flash', {
                            message: 'You are not authenticated. Please login first.',
                            position: 'top',
                            color: 'negative',
                            icon: 'error_outline'
                        });
                    }
                    // invalidate authentication (logout user)
                    store.dispatch('auth/' + auth_1.AUTH_LOGOUT, {})
                        .then(() => { }).catch(() => { }).then(() => {
                        // no matter server logout result -> redirect to login page (only if not already on login page)
                        if (!router.currentRoute.value.path.startsWith('/login')) {
                            redirect('/login' + (router.currentRoute.value.path !== '/' ? '?to=' + encodeURIComponent(router.currentRoute.value.fullPath) : ''));
                        } // else already on login page view - do not notify nor re-direct to login
                    });
                }
                else {
                    if (
                    //extensions.category === 'internal' &&
                    (message === null || message === void 0 ? void 0 : message.includes('Internal server error')) && (debugMessage === null || debugMessage === void 0 ? void 0 : debugMessage.length) &&
                        (debugMessage.includes('unauthorized') || // Laravel Gate/Policy
                            debugMessage.includes('Access denied')) // Laravel 403 exception (abort)
                    ) {
                        // Unauthorized request (user not authorized for requested action)
                        app.config.globalProperties.$event.emit('flash', {
                            message: 'Access denied. You do not have permission to perform this action or access this resource.',
                            position: 'top',
                            color: 'negative',
                            icon: 'error_outline'
                        });
                    }
                    else {
                        // flash only graphQL errors (including Internal Server Errors); ONLY FIRST
                        if (
                        // (extensions.category === 'graphql' || extensions.category === 'internal')
                        (message === null || message === void 0 ? void 0 : message.length)
                            && !flashed) {
                            app.config.globalProperties.$event.emit('flash', {
                                message: 'Server error: Internal server error',
                                position: 'top',
                                color: 'negative',
                                icon: 'error_outline'
                            });
                            flashed = true;
                        }
                    }
                }
                // flash authorization related errors
                if (extensions.category && extensions.category === 'authorization') {
                    // Unauthorized request (user not authorized for requested action)
                    app.config.globalProperties.$event.emit('flash', {
                        message: 'Access denied. You do not have permission to perform this action or access this resource.',
                        position: 'top',
                        color: 'negative',
                        icon: 'error_outline'
                    });
                }
                // flash custom message
                if (extensions.category && extensions.category === 'message') {
                    const status = extensions.status ? extensions.status : undefined;
                    app.config.globalProperties.$event.emit('flash', {
                        message: message,
                        position: 'top',
                        color: status,
                        icon: status === 'negative' ? 'error_outline' : 'warning'
                    });
                }
            });
        }
        if (networkError) {
            if (process.env.DEV) {
                console.error(`[Network error]: ${networkError}`);
            }
            // TODO: Handle real status codes instead of paring error messages
            const e = (networkError + '');
            const errMsg = e.includes('code 500') ? 'Server error: Internal server error' // 500
                : e.includes('Failed to fetch') ? "Network error: Could not connect to the server\n(you're offline or server down)"
                    : e.includes('Unexpected token') ? 'Server error: API service error' // 404
                        : 'Unknown network or server error';
            app.config.globalProperties.$event.emit('flash', {
                message: errMsg,
                position: 'top',
                color: 'negative',
                icon: 'error_outline'
            });
            store.dispatch('loadingRemove');
        }
    });
    // remove type names from responses
    const cleanTypeName = new core_1.ApolloLink((operation, forward) => {
        if (operation.variables) {
            const omitTypename = (key, value) => (key === '__typename' ? undefined : value);
            operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
        }
        return forward(operation).map((data) => {
            return data;
        });
    });
    // attach auth (authorization) header to headers
    const authMiddleware = new core_1.ApolloLink((operation, forward) => {
        operation.setContext({
            headers: {
                authorization: store.getters['auth/token'] ? `Bearer ${store.getters['auth/token']}` : null
            }
        });
        return forward(operation);
    });
    // HTTP connection to the API
    const httpLink = core_1.createHttpLink({
        uri: process.env.URL_API_GRAPHQL,
    });
    const links = core_1.ApolloLink.from([
        cleanTypeName,
        errorLink,
        httpLink
    ]);
    // Cache implementation
    const cache = new core_1.InMemoryCache();
    // Create the apollo client
    const apolloClient = new core_1.ApolloClient({
        link: authMiddleware.concat(links || httpLink),
        cache,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: 'cache-and-network',
                errorPolicy: 'ignore'
            },
            query: {
                fetchPolicy: 'network-only',
                errorPolicy: 'all'
            }
        }
    });
    const apolloProvider = apollo_option_1.createApolloProvider({
        defaultClient: apolloClient,
    });
    app.use(apolloProvider);
});
